import { useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormGroup from "@mui/material/FormGroup";
import Translate from "../utils/Translate";
import ButtonWithSpinner from "./ButtonWithSpinner";

export default function YesOrNoDialog({
  open,
  onNo,
  onYes,
  onCancel,
  title,
  text,
  content,
  yesText,
  noText,
  showCancelButton, // An extra button
  options = [], // Additional inputs shown under the text, e.g. checkboxes
}) {
  const [optionValues, setOptionValues] = useState({});

  const dialogContent = text ? <DialogContentText>{text}</DialogContentText> : content;

  return (
    <div>
      <Dialog
        className="yesOrNoDialog"
        open={open}
        onClose={async () => (onCancel ? await onCancel() : await onNo())}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
        <DialogContent style={{ whiteSpace: "pre-wrap" }}>
          {dialogContent}
          {options && options.length > 0 && (
            <FormGroup sx={{ mt: 2 }}>
              {options.map((option) => {
                if (option.type === "checkbox") {
                  return (
                    <FormControlLabel
                      key={option.key}
                      disabled={!!option.disabled}
                      control={
                        <Checkbox
                          checked={!!optionValues[option.key]}
                          onChange={(event) =>
                            setOptionValues((prev) => ({
                              ...prev,
                              [option.key]: event.target.checked,
                            }))
                          }
                        />
                      }
                      label={option.text}
                    />
                  );
                }
                return null;
              })}
            </FormGroup>
          )}
        </DialogContent>
        <DialogActions>
          {showCancelButton && (
            <ButtonWithSpinner onClick={async () => await onCancel()}>{Translate.get("Cancel")}</ButtonWithSpinner>
          )}
          <ButtonWithSpinner onClick={async () => await onNo()}>{noText ?? Translate.get("No")}</ButtonWithSpinner>
          <ButtonWithSpinner onClick={async () => await onYes(optionValues)} variant="contained" autoFocus>
            {yesText ?? Translate.get("Yes")}
          </ButtonWithSpinner>
        </DialogActions>
      </Dialog>
    </div>
  );
}
